import { render, staticRenderFns } from "./marketingTargetAdd.vue?vue&type=template&id=066db7a9&scoped=true"
import script from "./marketingTargetAdd.vue?vue&type=script&lang=js"
export * from "./marketingTargetAdd.vue?vue&type=script&lang=js"
import style0 from "./marketingTargetAdd.vue?vue&type=style&index=0&id=066db7a9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066db7a9",
  null
  
)

export default component.exports